<mat-form-field appearance="outline" class="language-selector">
  <mat-select [value]="currentLanguage" (selectionChange)="changeLanguage($event.value)">
    <mat-select-trigger>
      <div class="language-option">
        <img 
          [src]="globeIconPath" 
          alt="Language"
          class="globe-icon"
        >
        <span class="language-code">{{currentLanguage | uppercase}}</span>
      </div>
    </mat-select-trigger>
    <mat-option *ngFor="let lang of languages" [value]="lang.code">
      <div class="language-option">
        <img 
          [src]="globeIconPath" 
          alt="Language"
          class="globe-icon"
        >
        <span class="language-code">{{lang.code | uppercase}}</span>
      </div>
    </mat-option>
  </mat-select>
</mat-form-field>